<script lang="ts" setup>
import Message from 'primevue/message';
import Password from 'primevue/password';
import { AppFloatingLabelWrapper } from '~/components/base';
import type { FloatLabelVariant } from '~/types/components/base/FloatLabel';
import type {
  PasswordSize,
  PasswordVariant,
} from '~/types/components/base/Password';
import { IN } from '~/utils/enums/components/base/FloatLabel';

defineOptions({
  inheritAttrs: false,
});

/**
 * https://primevue.org/password/#api.password.props
 */
const {
  placeholder = undefined,
  label = undefined,
  variant = undefined,
  size = undefined,
  errorMessage = undefined,

  floatingLabel = true,
  floatingLabelVariant = IN,
  disabled = false,
  feedback = true,
  loading = false,
  toggleMask = true,
} = defineProps<{
  placeholder?: string;
  label?: string;
  variant?: PasswordVariant;
  size?: PasswordSize;
  errorMessage?: string;

  floatingLabel?: boolean;
  floatingLabelVariant?: FloatLabelVariant;
  disabled?: boolean;
  feedback?: boolean;
  loading?: boolean;
  toggleMask?: boolean;
}>();
</script>

<template>
  <AppFloatingLabelWrapper
    :floating-label="floatingLabel"
    :floating-label-variant="floatingLabelVariant"
    :label="label"
  >
    <template #default="{ labelId: id }">
      <Password
        :id="id"
        :variant="variant"
        :size="size"
        :disabled="disabled"
        :loading="loading"
        :feedback="feedback"
        :toggle-mask="toggleMask"
        :label="floatingLabel ? undefined : label"
        :placeholder="floatingLabel ? undefined : placeholder"
        class="app-password"
        v-bind="$attrs"
      />
    </template>
  </AppFloatingLabelWrapper>

  <Message
    v-if="!!errorMessage"
    severity="error"
    size="small"
    variant="simple"
    class="mt-2"
    >{{ errorMessage }}</Message
  >
</template>

<style lang="scss" scoped>
.app-password {
  :deep(input) {
    &:focus {
      background-color: #f0ffff;
    }
  }
}
</style>
